import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FileDownload } from '../models';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  /**
   * Reads the file and its name from a blob response. The encoded `filename*` wins over `filename`,
   * because only it carries characters beyond ASCII.
   */
  public fromResponse(response: HttpResponse<Blob>): FileDownload {
    return {
      file: new Blob([response.body!], { type: response.headers.get('Content-Type') || '' }),
      fileName: this.readFileName(response.headers.get('Content-Disposition') ?? '')
    };
  }

  /**
   * Hands the file to the browser as a download
   */
  public save(fileDownload: FileDownload): void {
    const link = document.createElement('a');
    const objectUrl = URL.createObjectURL(fileDownload.file);
    link.href = objectUrl;
    link.download = fileDownload.fileName;
    link.click();
    URL.revokeObjectURL(objectUrl);
  }

  private readFileName(contentDisposition: string): string {
    const parameters = contentDisposition
      .split(';')
      .map(parameter => parameter.trim());

    const encodedName = parameters.find(parameter => parameter.toLowerCase().startsWith('filename*='));
    if (encodedName) {
      const value = encodedName.substring('filename*='.length);
      const separatorIndex = value.indexOf("''");

      return decodeURIComponent(separatorIndex > -1 ? value.substring(separatorIndex + 2) : value);
    }

    const plainName = parameters.find(parameter => parameter.toLowerCase().startsWith('filename='));
    if (plainName) {
      return plainName.substring('filename='.length).replace(/^"(.*)"$/, '$1');
    }

    return '';
  }
}